import React from 'react';
import FadeUp from '../ui/FadeUp';
import SafeIcon from '@/common/SafeIcon';

export default function WhyUs() {
  const perks = [
    { icon: 'Home', title: 'Locally Owned', desc: "We're your neighbors — invested in the Eastern Shore community." },
    { icon: 'Zap', title: 'Fast Same-Day Service', desc: "Need it gone today? We make it happen when others can't." },
    { icon: 'DollarSign', title: 'Affordable Pricing', desc: 'Clear, upfront quotes with no hidden fees. Fair rates every time.' },
    { icon: 'Truck', title: 'We Do the Heavy Lifting', desc: "You don't lift a finger. We load everything up and haul it away." },
    { icon: 'Smile', title: 'Friendly Team', desc: 'Professional, courteous service from people who actually care.' },
  ];

  return (
    <section id="why-us" className="bg-dark-2 section-padding">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
        <div>
          <FadeUp>
            <div className="font-condensed text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4">Why Choose Us</div>
            <h2 className="font-condensed font-black text-[clamp(36px,4vw,56px)] uppercase leading-none mb-10 text-white">
              Local.<br/>
              Trusted.<br/>
              Affordable.
            </h2>
          </FadeUp>

          <div className="flex flex-col gap-6">
            {perks.map((perk, i) => (
              <FadeUp key={i} delay={i * 0.1} className="flex gap-4 items-start p-5 border border-dark-4 rounded bg-dark-3">
                <div className="w-10 h-10 shrink-0 bg-gold/10 rounded-full flex items-center justify-center text-gold text-lg">
                  <SafeIcon name={perk.icon} />
                </div>
                <div>
                  <strong className="block font-condensed text-[17px] font-bold uppercase mb-1 text-text">{perk.title}</strong>
                  <span className="text-sm text-text-muted">{perk.desc}</span>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>

        <FadeUp className="hidden lg:block relative">
          <div className="font-condensed font-black text-[clamp(80px,10vw,140px)] uppercase leading-[0.9] text-white/5 tracking-[-0.02em] select-none text-center">
            CLEAN<br/>
            SPACE<br/>
            FREE
          </div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center bg-gold text-dark w-[200px] h-[200px] rounded-full flex flex-col items-center justify-center shadow-[0_0_0_20px_rgba(232,168,32,0.08), 0_0_0_40px_rgba(232,168,32,0.04)]">
            <div className="font-condensed font-black text-[52px] leading-none mb-1 text-dark">⭐5</div>
            <div className="text-xs font-bold tracking-[0.1em] uppercase text-dark">Star Rated<br/>Service</div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}